import { useContext } from 'react';
import { PhonesChartsDataContext } from '../contexts/PhonesChartsDataContext';

export const usePhonesChartsDataContext = () => {
    return useContext(PhonesChartsDataContext);
};
